import { Component, inject, Input } from '@angular/core';
import { KpiWidgetComponent } from '../../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { BaseWidgetComponent } from '../../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../../_shared/services/filter.service';
import { formatCost, formatCostDifference, formatValue } from '../../../../../../_shared/helpers/kpiWidget/kpi-formatters.helper';
import { AuthService } from '../../../../../../_shared/services';
import { CurrencyHelper } from '../../../../../../_shared/helpers/currency/currency-map.helper';
import { TranslocoService } from '@jsverse/transloco';
import { MaintenanceDashboardService } from '../../../services/maintenance-dashboard.service';
import { ErrorHandlerService } from '../../../../../../_shared/services/error-handler.service';
import { AccountFilterRequest } from '../../../../../../_shared/models/account-filter.model';

@Component({
  selector: 'app-maintenance-cost-ytd',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './maintenance-cost-ytd.component.html',
  styleUrl: './maintenance-cost-ytd.component.scss'
})
export class MaintenanceCostYtdComponent extends BaseWidgetComponent {
  private readonly transloco = inject(TranslocoService);
  @Input() selectedFilter: string;
  private authService = inject(AuthService);
  private dashboardService = inject(MaintenanceDashboardService);
  private errorService = inject(ErrorHandlerService);

  currencySymbol: string = '';
  currencyCode: string = '';
  hasError: boolean = false;
  errorMessage: string = '';

  private loadedAccountIds: number[];

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);
    this.title = inject(TranslocoService).translate('maintenanceDashboard.widgets.maintenanceCostYtd');
    this.isLoading = true;
    this.value = 0;
    this.percentageDifference = 0;

    this.currencyCode = this.authService.getUserSettings()?.currencyCode ?? 'ZAR';
    this.currencySymbol = CurrencyHelper.getCurrencySymbol(this.currencyCode);
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    if (this.widgetFilter.accountIds === this.loadedAccountIds) {
      return;
    }
    this.loadedAccountIds = this.widgetFilter.accountIds;

    this.isLoading = true;
    this.hasError = false;

    try {
      this.cancelSubject.next();
      const request: AccountFilterRequest = {
        accountIds: this.widgetFilter.accountIds
      };
      const response = await this.dashboardService.getMaintenanceCostYtdSummary(request, this.cancelSubject);
      this.value = response.data?.totalValue ?? 0;
      this.percentageDifference = response.data?.percentageChange ?? 0;

      this.isLoading = false;
    } catch (error: any) {
      this.errorService.handleError(error, {
        callback: (errorMessage) => {
          this.hasError = true;
          this.errorMessage = errorMessage;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return formatValue(value, { currencySymbol: this.currencySymbol });
  }

  public formatCost(value: number): string {
    return formatCost(value, this.currencySymbol);
  }

  public formatCostDifference(value: number): string {
    return formatCostDifference(value, this.selectedFilter, this.currencySymbol, (key, params) => this.transloco.translate(key, params));
  }
}